// extracted by mini-css-extract-plugin
export default {"cls1":"AssignmentForm-Shortcuts-module--cls1--bSV3k","cls2":"AssignmentForm-Shortcuts-module--cls2--nLHmz AssignmentForm-Shortcuts-module--cls1--bSV3k"};